import { render, staticRenderFns } from "./CommunRecordModal.vue?vue&type=template&id=6d7a7ea2&scoped=true"
import script from "./CommunRecordModal.vue?vue&type=script&lang=js"
export * from "./CommunRecordModal.vue?vue&type=script&lang=js"
import style0 from "./CommunRecordModal.vue?vue&type=style&index=0&id=6d7a7ea2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a7ea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7a7ea2')) {
      api.createRecord('6d7a7ea2', component.options)
    } else {
      api.reload('6d7a7ea2', component.options)
    }
    module.hot.accept("./CommunRecordModal.vue?vue&type=template&id=6d7a7ea2&scoped=true", function () {
      api.rerender('6d7a7ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/HomeSchoolCommun/components/CommunRecordModal.vue"
export default component.exports